.flightTimes {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 0 calc(-1 * var(--space-s));

  & > * {
    flex: 1;
    padding: 0 var(--space-s);
  }

  .button {
    margin: 0 var(--space-s) var(--space-m);
  }
}
